import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from "@mui/styles";
import { authFetch, authPost } from "../../authProvider";

import { ConfirmCancelDialog } from '../ConfirmCancelDialog';
import { LanguageContext } from '../LanguageContext';
import LocalizedDatePicker from "../LocalizedDatePicker";

const defaultToolbarStyles = {
    iconButton: {},
};

const API_BASE = "/api/Mallipohja";

class PaastoIntensiteettiAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            Aika: null,
            Luokittelu_Id: null,
            Luokka_Id: null,
            LuokkaEuro: null,
            LuokkaCo2: null,
            Intensiteetti: null,
            Kommentti: null,
            Created: null,
            Updated: null,
            Username: null,
            paastoIntensiteetit: (Object.keys(props.lookupLists.paastoIntensiteetit).map((d) => ({ value: d, label: props.lookupLists.paastoIntensiteetit[d] })) || []),
            templates: [],
            selectedTemplate: null,
            selectedTemplateId: null,
            openTemplateDialog: false,
            templateName: "",
            templateFields: ["Luokittelu_Id", "Luokka_Id", "LuokkaEuro", "LuokkaCo2", "Intensiteetti"],
            loadingTemplates: false,
            loadingSave: false,
            loadingDelete: false,
        };
    }

    fetchTemplates = async () => {
        this.setState({ loadingTemplates: true });
        const ENTITEETTIID = 43;

        try {
            const resp = await authFetch(this.props.pca, `${API_BASE}/Read/` + ENTITEETTIID);
            if (resp.ok) {
                const data = await resp.json();
                const templates = data.map(t => ({
                    id: t.riviAvain,
                    label: t.nimi,
                    data: t.maaritys ? JSON.parse(t.maaritys) : {},
                    entiteettiId: t.entiteettiId
                }));
                this.setState({ templates });
            }
        } catch (e) {
            console.error("Template fetch error", e);
        } finally {
            this.setState({ loadingTemplates: false });
        }
    };

    saveTemplate = async (name, data) => {
        this.setState({ loadingSave: true });
        const ENTITEETTIID = 43;

        try {
            const payload = {
                RiviAvain: 1,
                EntiteettiId: ENTITEETTIID,
                Nimi: name,
                Kuvaus: "",
                Maaritys: JSON.stringify(data),
                Created: null,
                Updated: null,
                Username: this.state.Username || null
            };
            const resp = await authPost(this.props.pca, `${API_BASE}/Create`, {
                body: JSON.stringify(payload)
            });
            if (resp.ok) {
                await this.fetchTemplates();
                return true;
            } else {
                const error = await resp.text();
                alert("Virhe pohjan tallennuksessa: " + error);
                return false;
            }
        } catch (e) {
            alert("Virhe pohjan tallennuksessa.");
            return false;
        } finally {
            this.setState({ loadingSave: false });
        }
    };

    deleteTemplate = async (id) => {
        this.setState({ loadingDelete: true });
        try {
            const resp = await authFetch(this.props.pca, `${API_BASE}/Delete/${id}`);
            if (resp.ok) {
                this.setState(prev => ({
                    templates: prev.templates.filter(t => t.id !== id),
                    selectedTemplateId: null
                }));
            } else {
                alert("Virhe pohjan poistossa.");
            }
        } catch (e) {
            alert("Virhe pohjan poistossa.");
        } finally {
            this.setState({ loadingDelete: false });
        }
    };

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            Aika: null,
            Luokittelu_Id: null,
            Luokka_Id: null,
            LuokkaEuro: null,
            LuokkaCo2: null,
            Intensiteetti: null,
            Kommentti: null,
            Created: null,
            Updated: null,
            Username: null,
            templates: [],
            selectedTemplate: null,
            selectedTemplateId: null,
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            RiviAvain: 1,
            Aika: this.state.Aika?.format("MM/DD/YYYY 00:00:00"),
            Luokittelu_Id: this.state.Luokittelu_Id,
            Luokka_Id: this.state.Luokka_Id,
            LuokkaEuro: (this.state.LuokkaEuro || "").toString().replace(",", "."),
            LuokkaCo2: (this.state.LuokkaCo2 || "").toString().replace(",", "."),
            Intensiteetti: (this.state.Intensiteetti || "").toString().replace(",", "."),
            Kommentti: this.state.Kommentti || ''
        });

        this.handleClearData();
    };

    handleListChange = (event, newValue, item) => {
        this.setState({
            [item]: newValue ? newValue.value : null,
            jotainMuuttui: true
        });
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleChangeDate = (name, value) => {
        this.setState({
            [name]: value,
            jotainMuuttui: true
        });
    };

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    handleClickOpen = async () => {
        await this.fetchTemplates();
        this.setState({
            open: true,
            selectedTemplateId: null,
            Aika: null,
            Luokittelu_Id: null,
            Luokka_Id: null,
            LuokkaEuro: null,
            LuokkaCo2: null,
            Intensiteetti: null,
            Kommentti: null,
        });
    }

    render() {
        const { dictionary } = this.context;
        const {
            open, paastoIntensiteetit,
            templates, selectedTemplateId, selectedTemplate,
            openTemplateDialog, templateName, templateFields,
            loadingTemplates, loadingSave, loadingDelete
        } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.DataIngestion.PaastoIntensiteetti.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        {/*TODO: Template pois käytöstä */}
                        {/*<Autocomplete*/}
                        {/*    options={templates}*/}
                        {/*    getOptionLabel={(opt) => opt.label}*/}
                        {/*    loading={loadingTemplates}*/}
                        {/*    onChange={(event, newValue) => {*/}
                        {/*        if (newValue && newValue.data) {*/}
                        {/*            const newState = {};*/}
                        {/*            Object.entries(newValue.data).forEach(([key, value]) => {*/}
                        {/*                newState[key] = value;*/}
                        {/*            });*/}
                        {/*            this.setState({*/}
                        {/*                ...newState,*/}
                        {/*                selectedTemplateId: newValue.id,*/}
                        {/*                selectedTemplate: newValue,*/}
                        {/*            });*/}
                        {/*        } else {*/}
                        {/*            this.setState({*/}
                        {/*                selectedTemplateId: null,*/}
                        {/*                selectedTemplate: null,*/}
                        {/*            });*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*    value={selectedTemplate}*/}
                        {/*    renderInput={(params) => (*/}
                        {/*        <TextField {...params}*/}
                        {/*            label="Valitse valmispohja"*/}
                        {/*            variant="standard"*/}
                        {/*            fullWidth*/}
                        {/*            InputProps={{*/}
                        {/*                ...params.InputProps,*/}
                        {/*                endAdornment: (*/}
                        {/*                    <>*/}
                        {/*                        {loadingTemplates ? <CircularProgress size={20} /> : null}*/}
                        {/*                        {params.InputProps.endAdornment}*/}
                        {/*                    </>*/}
                        {/*                ),*/}
                        {/*            }}*/}
                        {/*        />*/}
                        {/*    )}*/}
                        {/*/>*/}

                        {/*<Box style={{ display: 'flex', gap: '10px', marginTop: 10 }}>*/}
                        {/*    <Button*/}
                        {/*        variant="outlined"*/}
                        {/*        onClick={() => this.setState({ openTemplateDialog: true })}*/}
                        {/*        disabled={loadingSave}*/}
                        {/*    >*/}
                        {/*        Tallenna valmispohja*/}
                        {/*    </Button>*/}
                        {/*    <Button*/}
                        {/*        variant="text"*/}
                        {/*        color="error"*/}
                        {/*        disabled={!selectedTemplateId || loadingDelete}*/}
                        {/*        onClick={async () => {*/}
                        {/*            if (window.confirm("Poistetaanko valittu pohja?")) {*/}
                        {/*                await this.deleteTemplate(selectedTemplateId);*/}
                        {/*            }*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        {loadingDelete ? <CircularProgress size={20} /> : "Poista valmispohja"}*/}
                        {/*    </Button>*/}
                        {/*</Box>*/}
                        
                        <LocalizedDatePicker
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[1]}
                            value={this.state.Aika}
                            onChange={(newValue) => this.handleChangeDate('Aika', newValue)}
                        />

                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[2]}
                            type="number"
                            fullWidth
                            value={this.state.Luokittelu_Id || ''}
                            onChange={this.handleChange('Luokittelu_Id')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[3]}
                            type="number"
                            fullWidth
                            value={this.state.Luokka_Id || ''}
                            onChange={this.handleChange('Luokka_Id')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[4]}
                            type="number"
                            fullWidth
                            value={this.state.LuokkaEuro || ''}
                            onChange={this.handleChange('LuokkaEuro')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[5]}
                            type="number"
                            fullWidth
                            value={this.state.LuokkaCo2 || ''}
                            onChange={this.handleChange('LuokkaCo2')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[6]}
                            type="number"
                            fullWidth
                            value={this.state.Intensiteetti || ''}
                            onChange={this.handleChange('Intensiteetti')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.DataIngestion.PaastoIntensiteetti.Columns[7]}
                            type="text"
                            fullWidth
                            multiline
                            rows={3}
                            value={this.state.Kommentti || ''}
                            onChange={this.handleChange('Kommentti')}
                        />
                    </DialogContent>
                    {/* TODO:THEME */}
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                    {/*<Dialog open={openTemplateDialog} onClose={() => this.setState({ openTemplateDialog: false })}>*/}
                    {/*    <DialogTitle>Tallenna valmispohja</DialogTitle>*/}
                    {/*    <DialogContent>*/}
                    {/*        <TextField*/}
                    {/*            label="Pohjan nimi"*/}
                    {/*            fullWidth*/}
                    {/*            value={templateName}*/}
                    {/*            onChange={e => this.setState({ templateName: e.target.value })}*/}
                    {/*        />*/}
                    {/*        {["Luokittelu_Id", "Luokka_Id", "LuokkaEuro", "LuokkaCo2", "Intensiteetti"].map(field => (*/}
                    {/*            <div key={field}>*/}
                    {/*                <label>*/}
                    {/*                    <input*/}
                    {/*                        type="checkbox"*/}
                    {/*                        checked={templateFields.includes(field)}*/}
                    {/*                        onChange={e => {*/}
                    {/*                            const selected = templateFields;*/}
                    {/*                            const updated = e.target.checked*/}
                    {/*                                ? [...selected, field]*/}
                    {/*                                : selected.filter(f => f !== field);*/}
                    {/*                            this.setState({ templateFields: updated });*/}
                    {/*                        }}*/}
                    {/*                    />*/}
                    {/*                    {field}*/}
                    {/*                </label>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*    </DialogContent>*/}
                    {/*    <DialogActions>*/}
                    {/*        <Button onClick={() => this.setState({ openTemplateDialog: false })}>Peruuta</Button>*/}
                    {/*        <Button*/}
                    {/*            variant="contained"*/}
                    {/*            disabled={loadingSave}*/}
                    {/*            onClick={async () => {*/}
                    {/*                const { templateFields, templateName } = this.state;*/}
                    {/*                if (!templateName.trim()) {*/}
                    {/*                    alert("Anna pohjalle nimi.");*/}
                    {/*                    return;*/}
                    {/*                }*/}
                    {/*                const data = {};*/}
                    {/*                templateFields.forEach(f => {*/}
                    {/*                    data[f] = this.state[f];*/}
                    {/*                });*/}
                    {/*                const ok = await this.saveTemplate(templateName.trim(), data);*/}
                    {/*                if (ok) {*/}
                    {/*                    this.setState({*/}
                    {/*                        openTemplateDialog: false,*/}
                    {/*                        templateName: "",*/}
                    {/*                        templateFields: ["Luokittelu_Id", "Luokka_Id", "LuokkaEuro", "LuokkaCo2", "Intensiteetti"]*/}
                    {/*                    });*/}
                    {/*                }*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            {loadingSave ? <CircularProgress size={20} /> : "Tallenna"}*/}
                    {/*        </Button>*/}
                    {/*    </DialogActions>*/}
                    {/*</Dialog>*/}
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "PaastoIntensiteettiAdd" })(PaastoIntensiteettiAdd);
